const normalizeBaseInterestKey = (value: string) =>
  value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .trim()
    .toUpperCase()
    .replace(/^TAG[\s_:-]*/i, '')
    .replace(/[^A-Z0-9]+/g, '_')
    .replace(/^_+|_+$/g, '');

export const normalizeInterestKey = (value: string) => {
  const normalized = normalizeBaseInterestKey(value || '');
  return normalized ? `TAG_${normalized}` : '';
};

export const buildInterestKeyFromLabel = (label: string) => normalizeInterestKey(label);
